var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commenting-replies",class:{
    'commenting-replies--is-new': _vm.type === 'new',
  }},[_c('div',{staticClass:"d-flex align-center justify-center commenting-replies__reply-count"},[_vm._v(" "+_vm._s(_vm.replyCount)+" ")]),_c('v-icon',[_vm._v("$commenting-replies")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }